import { CartProvider, ThemeProvider } from '@boost-sd/app';
import { createRoot } from 'react-dom/client';

export const initCart = () => {
  const cartContainerId = 'boost-sd__cart-container';
  const cartContainer = document.createElement('div');
  cartContainer.setAttribute('id', cartContainerId);
  const body = document.body;
  body.appendChild(cartContainer);
  if (
    window.boostSDAppConfig.themeSettings.cart.enableCart &&
    window.boostSDAppConfig.themeSettings.cart.cartStyle !== 'none'
  ) {
    body.classList.add('boost-sd-enable-ajax-cart');
  }

  const root = createRoot(cartContainer);

  const updateCartIconHeader = (cartItemCount: number) => {
    const mobileCartStatusElement = document.querySelector(
      '.header__mobile__button .header__cart__status'
    );
    if (mobileCartStatusElement) {
      mobileCartStatusElement.textContent = cartItemCount.toString();
      mobileCartStatusElement.setAttribute('data-cart-count', cartItemCount.toString());
    }

    const desktopCartStatusElement = document.querySelector(
      '.header__desktop__button .header__cart__status'
    );
    if (desktopCartStatusElement) {
      desktopCartStatusElement.textContent = cartItemCount.toString();
      desktopCartStatusElement.setAttribute('data-cart-count', cartItemCount.toString());
    }
  };

  root.render(
    <ThemeProvider>
      <CartProvider cartIconHeaderSelector='.navlink--cart' onUpdateCart={updateCartIconHeader} />
    </ThemeProvider>
  );

  // Check for the presence of the "boost-sd__modal" block and add/remove class from body accordingly. Base on this class we handle scrollable when open ajax cart
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList') {
        const modalBlock = document.querySelector('.boost-sd__modal');
        if (modalBlock) {
          body.style.overflow = 'hidden';
        } else {
          body.style.overflow = 'auto';
        }
      }
    }
  });

  observer.observe(body, { childList: true, subtree: true });
};
